import { ContentItem } from "./Components/types";

// MOVE
import img1 from './Images/Maquette/header.webp';
import img2 from './Images/Maquette/1.webp';
import img3 from './Images/Maquette/2.webp';
import vid from './Images/Maquette/video.webm';

const text = "A 70 m² interactive 3D-printed model of Amsterdam, installed in the lobby of the World Trade Center Amsterdam on the Zuidas. Crafted at a 1:2000 scale, the model presents the city’s historical fabric, current urban structure, and planned future developments with astounding detail — from canals and bridges to every tiny tuinhuisje. Through dynamic digital data, responsive lighting, and interactive storytelling, visitors can explore iconic buildings, urban themes, and the evolution of the city’s spatial landscape. The maquette serves as both an educational tool and a visual spectacle, inviting exploration of Amsterdam’s past, present, and future.";

const contributions = [
    "Lead developer - Responsible for the complete software architecture and implementation",
    "Development - Designed and built a framework connecting three synchronized displays: touchscreen, maquette projection, and external screen",
    "Development - Created the entire codebase from initial prototype to final installation",
    "Development - Developed custom shaders to visualize layered maps and spatial data of Amsterdam",
    "Development - Implemented interactive systems linking physical maquette elements with digital content",
    "Maintenance - Provided ongoing maintenance, updates, and stability improvements after installation",
    "Collaboration - Worked closely with Gemeente Amsterdam to gather, process, and integrate city data",
    "Collaboration - Coordinated with MVSA Architects to align software systems with the 3D-printed maquette",
    "Technical ownership - End-to-end responsibility for all software-related aspects of the project"
]

export const maquette: ContentItem = {
    title: "Maquette",
    chips: ['Interactive', 'City', '3D-printed', 'Projection mapping'],
    about: text,
    headerImage: img1,
    pageName: "/maquette",
    contributions: contributions,
    visualItems: [
        {
            path: vid,
            type: 'mutedvideo',
            poster: img1
        },
        {
            path: img2,
            type: 'image'
        },
        {
            path: img3,
            type: 'image'
        }
    ]
}

